// Hosts come from the environment so a local run can be pointed at a local API without editing
// (and later accidentally committing) this file.
//
// .env already carried REACT_APP_API_BASE_URL but nothing read it, so setting it appeared to do
// nothing and the portal kept talking to whatever was hardcoded here.
//
// The fallbacks on this branch are the STAGING hosts, matching what staging had before the values
// became configurable. Do not replace them with the production hosts when merging: an unset
// environment must keep pointing at staging, not production.
//
// Include the /api suffix in the value, e.g. https://localhost:7277/api
export const Config = {
  BASE_URL: process.env.REACT_APP_API_BASE_URL || 'https://api.s.insights.welbee.co.uk/api',
  ADMIN_BASE_URL: process.env.REACT_APP_ADMIN_BASE_URL || 'https://api.s.admin.welbee.co.uk/api',
  App_Url: process.env.REACT_APP_URL || 'https://s.pupil.welbee.co.uk',
}
